<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar área" : "Nueva área" }}
      </h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card
          tag="article"
          no-body
          style="max-width: 760px"
          class="custom-card"
        >
          <b-card-header
            header-tag="section"
            class="custom-card-header d-flex align-items-center"
          >
            <h3>
              {{
                editing
                  ? "Datos de la área"
                  : "Datos de la nueva área"
              }}
            </h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section mb-0">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <label for="description">Descripción *</label>
                    <input
                      id="description"
                      type="text"
                      v-model="form.description"
                      autocomplete="off"
                      placeholder="Descripción"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error': $v.form.description.$error,
                      }"
                    />

                    <FormError
                      v-if="$v.form.description.$error && !$v.form.description.required"
                      message="Descripción es requerida"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group-buttons text-right">
                <router-link
                  :to="{ name: 'area-list' }"
                  class="button button-light"
                >
                  {{ editing ? "Volver" : "Cancelar" }}
                </router-link>
                <button class="button button-primary" type="submit">
                  Guardar
                </button>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  FormError,
} from "wize-admin";

import { AreaService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  components: {
    FormError
  },
  data() {
    return {
      loading: true,
      showCalendar: false,
      identifierTypes: [
        LocalConstants.IdentifierType.DNI,
        LocalConstants.IdentifierType.LIBRETA_MILITAR,
        LocalConstants.IdentifierType.CARNET_MILITAR,
        LocalConstants.IdentifierType.CE,
        LocalConstants.IdentifierType.PASAPORTE,
      ],
      districts: [],
      form: {
        description: null
      },
      editing: false
    };
  },
  validations: {
    form: {
      description: { required }
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
    }),
  },
  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });

        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        const data = { ...this.form };

        let response;
        if (!this.editing) response = await AreaService.save(data);
        else
          response = await AreaService.update(this.$route.params.id, data);
        Alert.success("Se almacenó la información correctamente");
        if (!this.editing) {
          this.$router.push({
            name: "area-edit",
            params: { id: response.payload.id },
          });
          this.editing = true;
        }
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await AreaService.get(id);
        const payload = response.payload;
        this.form = {
          ...payload,
        };
        this.form.identifier = payload.identifier;
        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
        this.$router.push({ name: "area-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
  },
  async created() {
    if (this.$route.params.id) this.load(this.$route.params.id)
    else this.loading = false;
  },
};
</script>

<style lang="stylus" scoped></style>
